export default __webpack_public_path__ + "static/media/continue.6ce54447.svg";